import React, { useState, useEffect } from 'react';
import environmentConfig from '../config/environment';
import './EnvironmentToggle.css';

const EnvironmentToggle = () => {
  const [isProduction, setIsProduction] = useState(environmentConfig.isProduction());
  const [backendStatus, setBackendStatus] = useState(null);

  useEffect(() => {
    // Listen for environment changes
    const listener = (useProduction) => {
      setIsProduction(useProduction);
    };
    environmentConfig.addListener(listener);

    // Check backend status
    checkBackendStatus();

    return () => {
      environmentConfig.removeListener(listener);
    };
  }, []);

  const checkBackendStatus = async () => {
    try {
      const response = await fetch(`${environmentConfig.getApiBaseUrl()}/status`);
      if (response.ok) {
        const data = await response.json();
        setBackendStatus(data);
      }
    } catch (error) {
      console.log('Backend status check failed:', error);
    }
  };

  const handleToggle = () => {
    const targetEnv = isProduction ? 'Emulator' : 'Production';
    if (window.confirm(`Switch to ${targetEnv} mode? The page will reload.`)) {
      environmentConfig.toggleEnvironment();
    }
  };

  // Only show in development builds or when explicitly enabled
  if (process.env.NODE_ENV === 'production' && !process.env.REACT_APP_SHOW_ENV_TOGGLE) {
    return null;
  }

  return (
    <div className="environment-toggle">
      <div className="env-indicator">
        <span className={`env-badge ${isProduction ? 'prod' : 'emu'}`}>
          {isProduction ? 'PROD' : 'EMU'}
        </span>
        <button
          onClick={handleToggle}
          className="env-switch"
          title={`Currently using ${isProduction ? 'Production' : 'Emulator'}. Click to switch.`}
        >
          Switch to {isProduction ? 'Emulator' : 'Production'}
        </button>
        {backendStatus && (
          <span className="env-status" title={JSON.stringify(backendStatus, null, 2)}>
            Backend: {backendStatus.environment}
          </span>
        )}
      </div>
    </div>
  );
};

export default EnvironmentToggle;
